var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{on:{"click":function($event){return _vm.click()}}},[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }